import {microserviceHFDataApiRoot} from 'app/config';
import { httpGet,  buildUrl, parseSuccess } from './api';

export const getHighFrequencyData = (searchModel, state) => {
  var url = buildUrl(microserviceHFDataApiRoot, '/api/search/searchObservation',searchModel);
  return httpGet(url, state)
    .then(parseSuccess);
};
